import { render } from "./JoinView.vue?vue&type=template&id=19c1c09b&scoped=true&ts=true"
import script from "./JoinView.vue?vue&type=script&lang=ts"
export * from "./JoinView.vue?vue&type=script&lang=ts"

import "./JoinView.vue?vue&type=style&index=0&id=19c1c09b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c1c09b"]])

export default __exports__